import { isDefined } from 'dg-web-shared/lib/MaybeV2.ts';
import { FullSlideIn } from '../../ui/slidein/Slidein.tsx';
import * as ClearanceEditState from '../state/ClearanceEditState.ts';
import { useStore } from 'dg-web-shared/lib/Flux.tsx';
import * as ClearancePermitListState from '../../clearance-permit-list/state/ClearancePermitListState.ts';
import { ClearanceEdit } from './ClearanceEdit.tsx';

export function ClearanceSlideIn() {
    const { storeState } = useStore(store => ({
        clearancePermitList: new ClearancePermitListState.StateSlice(store)
            .state,
        layout: ClearanceEditState.Layout.get(store),
    }));

    const editContextEnabled = isDefined(
        storeState.clearancePermitList.selectedClearanceExternalId,
    );
    const content = editContextEnabled ? <ClearanceEdit /> : null;
    const isDisabled =
        storeState.layout.fromDatePickerOpen ||
        storeState.layout.toDatePickerOpen ||
        false;

    return (
        <FullSlideIn
            open={isDefined(content)}
            disabled={isDisabled}
            outsideBody
        >
            {content}
        </FullSlideIn>
    );
}
